"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var vega = _interopRequireWildcard(require("vega"));

var _vegaTooltip = require("vega-tooltip");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ColumnSelections = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../column-selections"));
  });
});

var getTooltipConfigFields = function getTooltipConfigFields(widget) {
  var vegaConfig = widget;

  if (!vegaConfig || !vegaConfig.interaction_config || !vegaConfig.interaction_config.length) {
    return [];
  }

  var tooltipConfig = vegaConfig.interaction_config.find(function (c) {
    return c.name === "tooltip";
  });

  if (!tooltipConfig || !tooltipConfig.config || !tooltipConfig.config.fields || !tooltipConfig.config.fields.length) {
    return [];
  }

  return tooltipConfig.config.fields;
};

var Chart =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(Chart, _react$default$Compon);

  function Chart(props) {
    var _this;

    _classCallCheck(this, Chart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chart).call(this, props));
    _this.vega = null;
    _this.state = {
      chartReady: false
    };
    _this.standalone = props.standalone || false;
    _this.handleResize = (0, _debounce["default"])(_this.handleResize.bind(_assertThisInitialized(_this)), 250);
    return _this;
  }

  _createClass(Chart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateVegaChart();
      window.addEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var widgetChanged = !(0, _isEqual["default"])(prevProps.widget, this.props.widget);
      var standaloneConfigChanged = !(0, _isEqual["default"])(prevProps.standaloneConfiguration, this.props.standaloneConfiguration);

      if (widgetChanged || standaloneConfigChanged) {
        this.generateVegaChart();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.vega) {
        window.removeEventListener("resize", this.handleResize);
        this.vega = null;
        this.setState({
          chartReady: false,
          invalidData: false
        });
        this.chart.innerHTML = '';
      }
    }
  }, {
    key: "setSize",
    value: function setSize() {
      if (this.view) {
        var computedStyles = getComputedStyle(this.view);
        var boundingRect = this.view.getBoundingClientRect();
        var padding = {
          top: +computedStyles.paddingTop.replace("px", ""),
          right: +computedStyles.paddingRight.replace("px", ""),
          bottom: +computedStyles.paddingBottom.replace("px", ""),
          left: +computedStyles.paddingLeft.replace("px", "")
        };
        this.width = boundingRect.width - (padding.left + padding.right);
        this.height = boundingRect.height - (padding.top + padding.bottom);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var view = this.view;

      if (view) {
        this.setSize();

        if (this.vega) {
          this.vega.width(this.width).run();
        }
      }
    }
  }, {
    key: "instantiateTooltip",
    value: function instantiateTooltip(widget) {
      var fields = getTooltipConfigFields(widget);
      (0, _vegaTooltip.vega)(this.vega, {
        showAllFields: false,
        fields: fields.map(function (_ref) {
          var column = _ref.column,
              property = _ref.property,
              type = _ref.type,
              format = _ref.format;
          return {
            field: column,
            title: property,
            formatType: type === "date" ? "time" : type,
            format: format
          };
        })
      });
    }
  }, {
    key: "generateRuntime",
    value: function generateRuntime(configuration) {
      var chart = this.chart;
      this.setSize();

      if (chart) {
        try {
          var runtime = vega.parse(configuration, configuration.config);
          this.vega = new vega.View(runtime).initialize(chart).renderer("svg").width(this.width).height(this.height).hover().run();

          if (configuration.interaction_config && configuration.interaction_config.length && !this.props.thumbnail) {
            this.instantiateTooltip(configuration);
          }

          this.setState({
            chartReady: true
          });
        } catch (err) {
          console.error("Widget editor error: Could not parse vega", err, configuration);
        }
      }
    }
  }, {
    key: "noDataAvailable",
    value: function noDataAvailable() {
      return !this.standalone && !this.props.advanced && (!this.props.editor.widgetData || this.props.editor.widgetData.length === 0);
    }
  }, {
    key: "verifyCustomChart",
    value: function verifyCustomChart(conf) {
      var _conf$config;

      var axisY = (conf === null || conf === void 0 ? void 0 : (_conf$config = conf.config) === null || _conf$config === void 0 ? void 0 : _conf$config.axisY) || {};
      delete axisY.labelAlign;
      delete axisY.labelBaseline;
      var config = conf.hasOwnProperty('config') ? _objectSpread({}, conf.config, {
        axisY: _objectSpread({}, axisY, {
          minExtent: 40
        })
      }) : {};
      return _objectSpread({}, conf, {
        config: config
      });
    }
  }, {
    key: "generateVegaChart",
    value: function generateVegaChart() {
      var _this$props = this.props,
          advanced = _this$props.advanced,
          thumbnail = _this$props.thumbnail,
          vegaConfiguration = _this$props.widget,
          standaloneConfiguration = _this$props.standaloneConfiguration;

      if (this.noDataAvailable()) {
        if (this.vega) {
          window.removeEventListener("resize", this.handleResize);
          this.vega = null;
          this.setState({
            chartReady: false,
            invalidData: true
          });
        }

        return;
      } else {
        this.setState({
          invalidData: false
        });
      }

      if (this.standalone && standaloneConfiguration) {
        if (thumbnail) {
          var clearAxis = standaloneConfiguration;
          delete clearAxis.axisX;
          delete clearAxis.axisY;
          delete clearAxis.axes;
          delete clearAxis.axis;
          this.generateRuntime(clearAxis);
        } else {
          this.generateRuntime(this.verifyCustomChart(standaloneConfiguration));
        }
      } else {
        if (!advanced) {
          delete vegaConfiguration.legends;
        }

        this.generateRuntime(vegaConfiguration);
      }
    }
  }, {
    key: "columnSelection",
    value: function columnSelection() {
      return _react["default"].createElement(_react.Suspense, {
        fallback: _react["default"].createElement("div", null, "Loading...")
      }, _react["default"].createElement(ColumnSelections, {
        compact: this.props.compact
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          thumbnail = _this$props2.thumbnail,
          standalone = _this$props2.standalone,
          _this$props2$advanced = _this$props2.advanced,
          advanced = _this$props2$advanced === void 0 ? false : _this$props2$advanced;
      var _this$state = this.state,
          chartReady = _this$state.chartReady,
          invalidData = _this$state.invalidData;
      return _react["default"].createElement(_styles.StyledContainer, {
        standalone: standalone,
        thumbnail: thumbnail,
        compact: this.props.compact,
        ref: function ref(c) {
          _this2.view = c;
        }
      }, !this.noDataAvailable() && _react["default"].createElement("div", {
        className: "c-chart",
        ref: function ref(c) {
          _this2.chart = c;
        }
      }), this.noDataAvailable() && _react["default"].createElement(_react.Fragment, null, chartReady && _react["default"].createElement(_styles.ChartNeedsOptions, null, "Select value & category to visualize data"), invalidData && _react["default"].createElement(_styles.ChartNeedsOptions, null, "No data available"), this.columnSelection()), !this.standalone && !advanced && this.columnSelection());
    }
  }]);

  return Chart;
}(_react["default"].Component);

Chart.defaultProps = {
  width: 0,
  height: 0
};
var _default = Chart;
exports["default"] = _default;